import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { AppConfig, CMPS_APP_CONFIG } from '../app.config';
import { mapList } from '../common/rest.operators';

import {
    Notification,
    NotificationCategory,
    NotificationCategoryModelTransformer,
    NotificationModelTransformer,
} from './notification.model';

@Injectable()
export class NotificationService {
    private _categories: NotificationCategory[];

    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    private _updateCommon(obs): Observable<boolean> {
        return obs.pipe(
            map((r: { ok: boolean }) => r.ok),
            catchError((error) => {
                console.error(error);
                return of(false);
            }),
        );
    }

    updateReadOn(notification: Notification): Observable<boolean> {
        const obs = this._http.put(
            `${this._appConfig.API_ENDPOINTS.NOTIFICATION}/notification/${notification.id}/r`,
            notification,
        );
        return this._updateCommon(obs);
    }

    updateAcknowledgeOn(notification: Notification): Observable<boolean> {
        const obs = this._http.put(
            `${this._appConfig.API_ENDPOINTS.NOTIFICATION}/notification/${notification.id}/a`,
            notification,
        );
        return this._updateCommon(obs);
    }

    updateDeleteOn(notification: Notification): Observable<boolean> {
        const obs = this._http.put(
            `${this._appConfig.API_ENDPOINTS.NOTIFICATION}/notification/${notification.id}/d`,
            notification,
        );
        return this._updateCommon(obs);
    }

    listCategories(forceReload?: boolean): Observable<NotificationCategory[]> {
        if (!forceReload && !!this._categories) {
            return of(this._categories);
        }
        return this._http
            .get(
                `${this._appConfig.API_ENDPOINTS.NOTIFICATION}/NotificationCategory`,
            )
            .pipe(
                mapList(new NotificationCategoryModelTransformer()),
                // eslint-disable-next-line no-return-assign
                map((model) => (this._categories = model)),
                catchError((error) => {
                    console.error(error);
                    throw new Error('NotificationCategory failed');
                }),
            );
    }

    list(): Observable<Notification[]> {
        return this._http
            .get(`${this._appConfig.API_ENDPOINTS.NOTIFICATION}/notification`)
            .pipe(
                mapList(new NotificationModelTransformer()),
                map((model) => model.filter((value) => !value.isDeleted)),
                catchError((error) => {
                    console.error(error);
                    throw new Error('notification failed');
                }),
            );
    }
}
